export default (theme) => ({
    root: {
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    overlay: {
        backgroundColor: theme.colors.primary.white,
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
    },
    skeletonBody: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        minHeight: 0,
    },
    skeletonRow: {
        display: 'flex',
        alignItems: 'center',
        boxSizing: 'border-box',
        width: '100%',
        paddingLeft: 16,
        paddingRight: 16,
        gap: 16,
        flexShrink: 0,
    },
    skeletonAvatar: {
        width: 24,
        height: 24,
        borderRadius: '50%',
        flexShrink: 0,
        backgroundColor: theme.colors.actionMinor[50],
    },
    skeletonBar: {
        height: 20,
        borderRadius: 4,
        flexShrink: 0,
        backgroundColor: theme.colors.actionMinor[50],
    },
    skeletonBarPrimary: {
        width: 205,
    },
    skeletonBarSecondary: {
        width: 240,
    },
    skeletonBars: {
        display: 'flex',
        flex: '1 1 auto',
        alignItems: 'center',
        gap: 16,
        minWidth: 0,
    },
    skeletonBarFlex: {
        flex: '1 1 0',
        minWidth: 40,
    },
});
